import { ContentfulProfileSectionAddtl } from 'ContentfulDefaults/types/profileAddtl';

export const profileAddtl: {
  profile_section_addtl: ContentfulProfileSectionAddtl;
} = {
  profile_section_addtl: {
    contentful_name: 'Profile Section Addtl (DEFAULT DO NOT CHANGE)',
    provider_preferences: {
      contentful_name: '[DEFAULT] Provider Preferences Card',
      name: 'Provider Preferences',
      tooltips: {
        name: {
          text: "A network is a group of doctors and hospitals with which a medical plan has negotiated lower costs. You'll likely pay much less to see an in-network provider than an out-of-network provider.",
          title: 'Provider Preferences',
          underline: 'Provider Preferences',
        },
      },
      yes_label: 'Yes',
      no_label: 'No',
      questions: {
        11: {
          question:
            'If it could save you money, would you be willing to choose a medical plan with fewer in-network doctors and hospitals in your area?',
          tooltip: {
            name: {
              text: 'A narrow network covers fewer providers, but may offer lower premiums. ALEX may still highlight a plan with a narrow network if there are substantial cost savings.',
              title: '',
              underline: 'fewer in-network doctors and hospitals',
            },
          },
        },
        12: {
          question: 'Will you need access to doctors and hospitals outside of your home region?',
          tooltip: {
            name: {
              text: 'A national network covers providers all over the country. This may be important if you travel a lot, work remotely, or are covering a child who lives elsewhere.',
              title: '',
              underline: 'outside of your home region',
            },
          },
        },
        13: {
          question:
            'If it could save you money, would you be willing to choose a plan that requires a referral from your primary care provider before seeing a specialist?',
          tooltip: {
            name: {
              text: "Certain plan types coordinate all care through your primary care provider. This means you'll need to get their recommendation to see a specialist, rather than seeking one out yourself.",
              title: '',
              underline: 'referral from your primary care provider',
            },
          },
        },
      },
    },
    medicare_info_card: {
      contentful_name: 'Medicare Info Section (DEFAULT DO NOT CHANGE)',
      profile_side_panel_header: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                value: '¿Quiere aprender más sobre Medicare?',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      profile_side_panel_details: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'ALEX puede ayudarle a usted o a un ser querido a elegir el plan adecuado.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      profile_side_panel_button_text: 'Visite ALEX Medicare',
      profile_callout_question: '¿Ya se ha inscrito en Medicare?',
      profile_callout_button_options: {
        no: 'No',
        yes: 'Si',
      },
      profile_callout_learn_more:
        '¿Quiere aprender más sobre Medicare y cómo empezar? Haga clic en el botón a continuación para abrir ALEX Medicare en otra pestaña.',
      profile_callout_tooltips: {
        name: {
          text: 'Medicare es un programa federal que proporciona seguro de salud, principalmente a personas de 65 años en adelante. Usted puede ser elegible antes si tiene ciertas discapacidades o enfermedades.',
          title: 'Medicare',
          underline: 'Medicare',
        },
      },
      profile_callout_name: 'Medicare',

      text_notes: [
        {
          plan_year: '2026',
          short_text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '¡Podemos incluir una nota de texto personalizada aquí de hasta 140 caracteres!',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          long_text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '¡Aquí puede ir información adicional, hasta 5000 caracteres!',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          button_text: 'Lea más',
        },
      ],

      pronoun_map: {
        i: '',
        they: '',
        you: '',
      },
    },
    profile_eligibility_rules: [
      {
        plan_year: '2026',
        long_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              data: {},
              content: [
                {
                  nodeType: 'text',
                  value:
                    'Podemos incluir información adicional sobre las reglas de elegibilidad para mostrar u ocultar ciertas secciones en el perfil aquí. Esta es una función personalizada, así que contáctenos si está interesado en usarla.',
                  marks: [],
                  data: {},
                },
              ],
            },
          ],
        },
      },
    ],
  },
};

export default profileAddtl;
